import { render, staticRenderFns } from "./ArticlesModal.vue?vue&type=template&id=71078b0e&"
import script from "./ArticlesModal.vue?vue&type=script&lang=js&"
export * from "./ArticlesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports